// ID pixeli per kod sprzedawcy: sellerTrackingConfig.js.

const FB_EVENTS_SCRIPT_URL = "https://connect.facebook.net/en_US/fbevents.js";

const initializedPixelIds = new Set();

// Odpowiednik oficjalnego snippetu Meta Pixel, bez init/PageView na sztywno.
// Zwykle fbq już istnieje — GTM ładuje główny pixel GO-auto.
function loadScript() {
    if (window.fbq) {
        return;
    }

    const fbq = window.fbq = function () {
        fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };

    if (!window._fbq) {
        window._fbq = fbq;
    }

    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.queue = [];

    const script = document.createElement("script");
    script.async = true;
    script.src = FB_EVENTS_SCRIPT_URL;

    const firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(script, firstScript);
}

// Wysyła PageView tylko dla bieżącej strony. PageView przy zmianie trasy (pushState
// react-routera) fbevents.js wysyła już sam do wszystkich zainicjowanych pixeli —
// ręczne wysyłanie dublowałoby zdarzenia.
function init(pixelId) {
    if (initializedPixelIds.has(pixelId)) {
        return;
    }

    loadScript();
    window.fbq("init", pixelId);
    // trackSingle — PageView tylko do tego pixela, bez ponownego PageView dla pixela z GTM.
    window.fbq("trackSingle", pixelId, "PageView");
    initializedPixelIds.add(pixelId);
}

export default {
    init,
}
